import { Component, OnInit, ViewContainerRef , ViewChild , ElementRef, Renderer2, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { GlobalEventMangerService } from '../global-event-manger.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.css'],
  providers: [Modal]
})
export class PackageComponent implements OnInit, OnDestroy {
	@ViewChild('CreditCardSec') CreditCardSec: ElementRef;
	showSectionFlag: boolean = false;

  public freetrial: any = {};
	public signupPlanList:any[] = [];;
	public token: string;
	public _id: string;
	public showCreditCard:boolean = false;
	busy: Subscription;
	selected_plan_id:string = '';
	selected_plan_name:string = '';
	selected_Message:string = '';
	activationSuccess_Message:string = '';
	public formTouched : boolean = false;
	public userFirstName : string;
	public userLastName : string;
	public mask: Array<string | RegExp>;
	public MonthError : boolean = false;
	public YearError : boolean = false;
	public CVCError : boolean = false;
	public CardError : boolean = false;
	public MaxYear : boolean = false;
	public CardErrorMessage : string;

  constructor(private userService: UserService, private elementRef: ElementRef, private renderer: Renderer2, private toastr: ToastrService, private router: Router, vcRef: ViewContainerRef, public modal: Modal, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService) { 
    var currentUser = this.localStorageService.getData("currentUserToken");;
    this.token =  currentUser && currentUser.data.user_token;
    let userDetails = this.localStorageService.getData("currentUser");
    this._id = userDetails && userDetails._id;
	this.userFirstName = userDetails && userDetails.first_name;
	this.userLastName = userDetails && userDetails.last_name;
	this.mask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
	if(currentUser && currentUser.data.is_steps_completed) {
		this.router.navigate(['/dashboard']);
	  }
  }

  ngOnDestroy() {
    this.toastr.clear();
  }
  
  ngOnInit() {
	this.getVerifyStep();
    this.getSignUpPlan();
  }

  getVerifyStep() {
	let data = {
	  user_token:this.token,
	}
	let responseData = <any>{};
	this.busy = this.userService.GetVerifySteps(data).subscribe(
	   response => {
		  responseData = response;
		  if (!responseData.data.phone || !responseData.data.bank || !responseData.data.document) {
			this.router.navigate(['/get-started-deposits']);
		  }
	   },
	   error => {
			responseData = error;
	   }
	);
}

  getColumnClass(length: number): string {
	if (length === 3) {
	  return 'col-md-4 col-sm-6 col-xs-12';
	} else if (length === 4) {
	  return 'col-md-3 col-sm-6 col-xs-12';
	} else {
	  // Default column class when length is neither 3 nor 4
	  return 'col-md-4 col-sm-12 col-xs-12';
	}
  }
  
  @ViewChild('submitButton') submitButton: ElementRef;
  moveNext(nextInput: HTMLInputElement, checkbox) {
	if(checkbox === 2){
		const saveButton = document.getElementById('submitButton') as HTMLElement;
		if (saveButton) {
		  saveButton.focus();
		  saveButton.click();
		}
	} else {
	  nextInput && nextInput.focus();
	}
  }

  showCreditCardFunc(plan_id='', plan_name='') {
	setTimeout(() => {
		this.scrollToSection();
	}, 100);
	this.showCreditCard = true;
	this.selected_plan_id = plan_id;
	this.selected_plan_name = plan_name;
  }
  scrollToSection() {
	if (this.CreditCardSec) {
	  this.CreditCardSec.nativeElement.scrollIntoView({ behavior: 'smooth' });
	  this.renderer.selectRootElement('#initialFocus').focus();
	}
  }
  // Get Sign up Plan
	getSignUpPlan() {
		var data = {
			token:this.token
		}

    let responseData = <any>{};
    this.busy = this.userService.getAllSignupPlan(data).subscribe(	
	    response => {
			  responseData = response;
			  this.signupPlanList  = responseData.data.sort((a,b) => a.amount - b.amount);
	    },
	    error => {
			  responseData = error;
			  this.toastr.error(responseData.error.message, 'Failed!');
	    }
	  );
	}

	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
		  firstElementWithErrors.focus();
		}
	  }

	  monthDiff(dateFrom, dateTo) {
		return dateTo.getMonth() - dateFrom.getMonth() + 
		  (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
	   }

  // Signup free trial
	signupFreeTrial(data) {
		this.focusFirstInvalidControlPlus();   //focus field
		this.formTouched = true;

		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1;
	  
		const enteredYear = parseInt(data.form.value.exp_year, 10);
		const enteredMonth = parseInt(data.form.value.exp_month, 10);

		if (enteredYear < currentYear) {
				const businessNameElement = document.querySelector('#inputYear') as HTMLInputElement;
				if (businessNameElement) {
					this.renderer.selectRootElement(businessNameElement).focus();
					this.YearError = true;
				}
				return
		  } else if (enteredYear === currentYear && enteredMonth < currentMonth) {
			    this.YearError = false;
				const businessNameElement = document.querySelector('#inputMonth') as HTMLInputElement;
				if (businessNameElement) {
					this.renderer.selectRootElement(businessNameElement).focus();
					this.MonthError = true;
				}
				return
		  } else if (this.monthDiff(new Date(currentYear, currentMonth), new Date(enteredYear, enteredMonth)) > 72) {
			this.YearError = false;
			this.MonthError = false;
			const businessNameElement = document.querySelector('#inputYear') as HTMLInputElement;
			if (businessNameElement) {
				this.renderer.selectRootElement(businessNameElement).focus();
				this.MaxYear = true;
			}
			return
	  }
		  
		this.MonthError = false;
		this.YearError = false;
        this.CardError = false;
		this.CardErrorMessage = '';
        this.CVCError = false;
		this.MaxYear = false;
		if(data.valid){
			let model: any = data.value;
			model.token = this._id;
			model._id = this._id;
			model.user_token = this.token;
			model.plan = this.selected_plan_id;

			let responseData = <any>{};
			this.busy =  this.userService.getStripeToken(model).subscribe(
			response => {
			responseData = response;
			this.MonthError = false;
			this.YearError = false;
			this.MaxYear = false;
			this.CardErrorMessage = '';
			this.selected_Message = '';
				var sdata = {
					stripe_token : responseData.data.id,
					plan : model.plan,
					token : this._id,
					user_token : this.token,
					_id : this._id,
				}
				this.signupFreeTrialSubscribe(sdata);
				// setTimeout(()=>{
				// 	this.activationSuccess_Message = 'Card details Updated';
				// }, 5000)
			},
			error => {
					responseData = error;
					this.selected_Message = responseData.error.message;
					if (responseData.error.message.indexOf('card number') > -1 ||
					responseData.error.message.indexOf('credit card') > -1) {
						const businessNameElement = document.querySelector('#initialFocus') as HTMLInputElement;
						if (businessNameElement) {
						  this.renderer.selectRootElement(businessNameElement).focus();
						  this.CardError = true;
						  this.CardErrorMessage = responseData.error.message;
						}
					}
					if (responseData.error.message.indexOf('year') > -1) {
						const businessNameElement = document.querySelector('#inputYear') as HTMLInputElement;
						if (businessNameElement) {
						  this.renderer.selectRootElement(businessNameElement).focus();
						  this.YearError = true;
						}
					}
					if (responseData.error.message.indexOf('month') > -1) {
						const businessNameElement = document.querySelector('#inputMonth') as HTMLInputElement;
						if (businessNameElement) {
						  this.renderer.selectRootElement(businessNameElement).focus();
						  this.MonthError = true;
						  this.CardErrorMessage = '';
						}
					}
		
					if (responseData.error.message.indexOf('cvc') > -1) {
						const businessNameElement = document.querySelector('#inputCvc') as HTMLInputElement;
						if (businessNameElement) {
						  this.renderer.selectRootElement(businessNameElement).focus();
						  this.CVCError = true;
						}
					}
					// this.toastr.error(responseData.error.message, 'Failed!');
			}
			);
		}
		
	}


	// Signup free trial subscribe
	signupFreeTrialSubscribe(data) {
	  let responseData = <any>{};
	  this.busy = this.userService.signupFreeTrialSubscribeApi(data).subscribe(
	   response => {
		 responseData = response;
		 this.selected_Message = '';
         this.activationSuccess_Message = 'Free trial Successfully activated in your account.';
		 this.freetrial = {};
		 this.freetrial.number = '';
		 this.freetrial.exp_month = '';
		 this.freetrial.exp_year = '';
		 this.freetrial.cvc = '';
		 this.formTouched = false;
		this.getAuth();
	   },
	   error => {
			responseData = error;
			this.selected_Message = responseData.error.message;
			//this.toastr.error(responseData.error.message, 'Failed!');
	  	}
	);
	}

	getAuth() {
		let authData = <any>{};
		let current_User = this.localStorageService.getData("currentUserToken");
		let token = current_User.data.user_token;
		this.busy = this.userService.getAuthUserByToken(token).subscribe(
			response => {
			 	authData = response;

			 	let parsed_currentUserToken = this.localStorageService.getData("currentUserToken");
				parsed_currentUserToken.data.settings = authData.data.settings;
				parsed_currentUserToken.data.is_steps_completed = true;
				this.localStorageService.setData("currentUserToken", parsed_currentUserToken);
				let parsed_currentUser = this.localStorageService.getData("currentUser");
				parsed_currentUser.settings = authData.data.settings;
				parsed_currentUser.subscriptions = authData.data.subscriptions;
			 	this.localStorageService.setData("currentUser", parsed_currentUser);
			 
			 	this.globalEventMangerService.showNavBar(true);

			 	this.router.navigate(['/dashboard']);
			},error => {
				authData = error;
				this.toastr.error(authData.error.message, 'Failed!');
		   	}
		);
	}

	// Allowing  Number only
	validateNumberInput(event: any) {
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  // Allow the default behavior for certain keys
		  return;
		}
	  
		if (!/^\d+$/.test(event.key)) {
		  // Prevent input if it's not a digit
		  event.preventDefault();
		}
	  }

	   // Logout link
	logOut(){
		let currentUser = this.localStorageService.getData("currentUserToken");
        let token =  currentUser.data.user_token;
		this.userService.userLogout(token).subscribe(
			response => {
				console.log('User logout successfully');
			}
		);
		this.localStorageService.removeData('currentUser');
		this.localStorageService.removeData('currentUserToken');
		this.localStorageService.removeData('super_admin_detail');
		this.localStorageService.removeData('super_admin_token');
		this.localStorageService.removeData("Profile_image")
		this.localStorageService.removeData('Mer_Profile_image');
		this.globalEventMangerService.ghostLogin(false);
		this.localStorageService.removeData('merchantAdmin');
		let merchantAdmin = this.localStorageService.getData("merchantAdmin");
		this.globalEventMangerService.showNavBar(false);
		this.router.navigate(['/login']);
	}
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/package/package.component.ts